'use client';

import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

const CTASection = () => {
  return (
    <div className="bg-gradient-to-br from-primary to-primary/80 rounded-xl shadow-elevation-lg p-8 text-center">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="inline-flex items-center justify-center rounded-full bg-primary-foreground/10 px-4 py-2 mb-2">
          <Icon name="SparklesIcon" size={20} className="text-primary-foreground mr-2" />
          <span className="font-caption text-xs font-medium uppercase tracking-wider text-primary-foreground">
            Ready to Save?
          </span>
        </div>

        <div className="space-y-3">
          <h2 className="font-heading text-3xl font-bold text-primary-foreground">
            Find Trusted Mechanics Near You
          </h2>
          <p className="font-body text-base text-primary-foreground/90 leading-relaxed">
            Connect with verified independent repair shops in your area and start saving on your next service
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 pt-4">
          <Link
            href="/search-results"
            className="flex items-center justify-center space-x-2 rounded-lg bg-primary-foreground px-8 py-4 font-body text-base font-medium text-primary shadow-elevation-md transition-smooth hover:opacity-90 active:scale-[0.97]"
          >
            <Icon name="MagnifyingGlassIcon" size={20} />
            <span>Search Mechanics</span>
          </Link>

          <Link
            href="/oem-parts-finder"
            className="flex items-center justify-center space-x-2 rounded-lg border-2 border-primary-foreground/30 bg-primary-foreground/10 px-8 py-4 font-body text-base font-medium text-primary-foreground transition-smooth hover:bg-primary-foreground/20 active:scale-[0.97]"
          >
            <Icon name="CubeIcon" size={20} />
            <span>Find OEM Parts</span>
          </Link>
        </div>

        <div className="pt-6 border-t border-primary-foreground/20">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex flex-col items-center space-y-2">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-foreground/10">
                <Icon name="ShieldCheckIcon" size={24} className="text-primary-foreground" />
              </div>
              <p className="font-body text-sm text-primary-foreground/90 text-center">
                Verified Shops
              </p>
            </div>

            <div className="flex flex-col items-center space-y-2">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-foreground/10">
                <Icon name="CurrencyDollarIcon" size={24} className="text-primary-foreground" />
              </div>
              <p className="font-body text-sm text-primary-foreground/90 text-center">
                Best Prices
              </p>
            </div>

            <div className="flex flex-col items-center space-y-2">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-foreground/10">
                <Icon name="StarIcon" size={24} className="text-primary-foreground" />
              </div>
              <p className="font-body text-sm text-primary-foreground/90 text-center">
                Top Rated
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;